import styled from '@emotion/styled'
import theme from '@utils/theme'

export const AddOnsLabel = styled.p`
  color: ${theme.colors.text};
  font-size: 14px;
  transform: translateX(18px);
`

export const outlineButton = `
  background: transparent;
  color: ${theme.colors.primary};
  border: 1px solid ${theme.colors.primary};
  width: 100%;
`

export const AddButtonWrapper = styled.div`
  width: 100%;
`

export const AddOnWrapper = styled.div`
  display: flex;
  column-gap: 14px;
  align-items: center;
  padding: 10px;
  border: 1px solid ${theme.colors.borderColor};
  border-radius: 5px;

  width: fit-content;
`

export const AddOnImage = styled.img`
  background-color: #faf0ff;
  width: 40px;
  aspect-ratio: 1 / 1;
  border-radius: 100vh;
  object-fit: cover;
`

export const AddOnInfo = styled.div`
  .title {
    color: #343f52;
  }

  .points {
    color: #a0a0a0;
    font-size: 12px;
  }
`

export const FormTopSection = styled.div`
  display: flex;
  gap: 20px;
`
